import {
  Sidebar,
  SidebarBody,
  SidebarSection,
  SidebarItem,
  SidebarLabel,
} from "../tailwind/sidebar";
import { Button } from "../tailwind/button";

export function SetupSidebar({
  customerSteps,
  currentStep,
  nextStep,
  progression,
  onStepChange,
  onComplete,
  children,
  setCustomerSteps,
  handleCompleteSetup,
}) {
  const handleStepClick = (step) => {
    onStepChange(step);
  };

  const classLabel =
    "ml-6 hover:bg-grey rounded-customBorderRadius my-1 bg-grey leading-3 pl-[2px]";

  console.log(Object.keys(customerSteps).sort());

  return (
    <>
      <div className="flex h-full">
        <Sidebar className="w-[40%] border-r m-0 p-0 border-box h-full">
          <SidebarBody className="justify-between">
            <SidebarSection
              style={{ height: "100%" }}
              className="flex flex-col justify-center w-full"
            >
              {Object.keys(customerSteps)
                .sort()
                .map((step) =>
                  step !== "completed" ? (
                    <SidebarItem
                      key={step}
                      onClick={() => handleStepClick(step)}
                      current={step === currentStep}
                      className={classLabel}
                      nextstep={step === nextStep ? "true" : undefined}
                      disabled={
                        !customerSteps[step]?.validate && step !== nextStep
                      }
                      setup="true"
                      checked={customerSteps[step]?.validate}
                    >
                      <SidebarLabel className="py-2">
                        {customerSteps[step]?.name}
                      </SidebarLabel>
                    </SidebarItem>
                  ) : null
                )}
            </SidebarSection>
            <Button
              color="primaryButton"
              onClick={() => handleCompleteSetup()}
              disabled={progression !== 100}
            >
              {customerSteps.completed ? "Setup completed!" : "Finish setup"}
            </Button>
          </SidebarBody>
        </Sidebar>
        <div className="flex flex-col w-full ">{children}</div>
      </div>
    </>
  );
}
